import { Divider, Drawer, Space, Checkbox, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import ColourPicker from "../../../globals/styles/ColourPicker";
import SliderInput from "../../UI/SiderInput";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import ListSelect from "../../ListSelect";
import { apiCall } from "../../../utils/Api";
import wrap from "../../../utils/wrap";
import ProductCarousel from "../../UI/ProductCarousel";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_name_block_warning, tt_ps_gap, tt_ps_list, tt_ps_padding_x, tt_ps_padding_y } from "../../../utils/Utils";
import LinkPicker from "../../../globals/styles/LinkPicker";
import Scroller from "../../UI/Scroller";

export default function ProductSlider(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [template,] = useTemplate();
    const [content, setContent] = useState(props.content);
    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        display_mode = "scroller",
        image_size = 120,
        constrain_container = false,
        max_width = 300,
        padding_y = 10,
        padding_x = 10,
        gap = 10,
        list_id = "",
        limit = 16,
        show_title = false,
        title_preset = 0,
        show_author = false,
        author_preset = 0,
        background_colour = 0,
        button_type = 0,
        link_id = 0,
    } = data;

    const scroller = (display_mode === "scroller") ? true : false;
    const [items, setItems] = useState({rows : [], row_count : 0});

    const getItems = () => {
        if (!list_id) {
            setItems({rows : [], row_count : 0});
            return;
        }
        apiCall("titlelist/getItems", { list_id: list_id, limit: limit }, (_status, _result) => {
            if (_status) {
                setItems(_result);
            }
        }, "customer")
    }

    useEffect(getItems, [list_id]);

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawItem = (_item) => {
        let _coverStyle = {
            cursor: "pointer",
            // overflow: "hidden",
        }

        let _imgStyle = {}

        if (scroller) {
            _imgStyle.height = (image_size * 1.5) + "px";
            _imgStyle.width = "auto"; 
            _imgStyle.maxWidth = constrain_container ? max_width + "px" : ""; 
            _imgStyle.objectFit = constrain_container ? "contain": "";
        } else {
            _coverStyle.maxWidth = image_size + "px";
            _imgStyle.width = "100%";
        }

        return (
            <div style={_coverStyle} key={_item.eisbn}>
                <img draggable={false} className="bm-img-link" onError={(e) => e.target.src = "https://bookmanager.com/i/nocover.png"} style={_imgStyle} src={"https://bookmanager.com/i/n?b=" + _item.eisbn + "&cb=" + _item.cover_image_cache} />
                <div style={{ whiteSpace: "initial" }}>
                    <wrap.is value={(show_title)}>
                        <div className="shim" />
                        <div style={{ "display": "block" }} className={"bm-txt-" + title_preset}>{_item.title}</div>
                    </wrap.is>
                    <wrap.is value={(show_author)}>
                        <div className={"bm-txt-" + author_preset}>{_item.authors.slice(0, 1).map(item => item.name).join(", ")}</div>
                    </wrap.is>
                </div>
            </div>
        )
    }


    const drawPlaceholder = (_index) => {

        let _coverStyle = {
            cursor: "pointer",
            overflow: "hidden",
        }

        let _imgStyle = {}

        if (scroller) {
            _imgStyle.height = (image_size * 1.5) + "px";
            _imgStyle.width = "auto";

        } else {
            _coverStyle.maxWidth = image_size + "px";
            _imgStyle.width = "100%";
        }

        return (
            <div style={_coverStyle} key={_index}>
                <img draggable={false} style={_imgStyle} src={"https://bookmanager.com/i/sample_content/title_placeholder.jpg"} />
                <wrap.is value={(show_title)}>
                    <div className="shim" />
                    <div style={{ "display": "block" }} className={"bm-txt-" + title_preset}>Title</div>
                </wrap.is>
                <wrap.is value={(show_author)}>
                    <div className={"bm-txt-" + author_preset}>Author</div>
                </wrap.is>
            </div>
        )
    }

    const drawRender = () => {
        const sliderStyle = {
            background: getColor(background_colour, template),
            padding: `${padding_y}px ${padding_x}px`,
        };

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={sliderStyle}>
                    {(!scroller &&
                        <ProductCarousel button_type={button_type} image_size={image_size} gap={gap} drawPlaceholder={drawPlaceholder} drawItem={drawItem} limit={limit} images={items.rows.slice(0, limit)} />
                    )}
                    {(scroller &&
                        <Scroller button_type={button_type} image_size={image_size} gap={gap} drawPlaceholder={drawPlaceholder}  >
                            {items.rows.slice(0, limit).map(item => {
                                return drawItem(item)
                            })}
                            {((items.rows.length === 0) &&
                                Array.from({ length: limit }, (_, index) => index + 1).map(item => {
                                    return drawPlaceholder(item)
                                })
                            )}
                        </Scroller>
                    )}
                    <div className="shim" />
                    <div className="float-flex">
                        <div>&nbsp;</div>
                        <div><a className={"bm-txt-0 bm-lnk-"+link_id}>View all {(items.row_count) ? <>{items.row_count} </> : ""}products</a></div>
                    </div>
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />

                {/* SIZE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DISPLAY TYPE</Divider>
                <Select value={display_mode} onChange={(e) => setData({ ...data, "display_mode": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={"carousel"} value={"carousel"}><small>Carousel</small></Select.Option>
                    <Select.Option key={"scroller"} value={"scroller"}><small>Drag Scroller</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />

                {/* LIST */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider"><Tooltip title={tt_ps_list}>MY LIST</Tooltip></Divider>
                <ListSelect value={list_id} onChange={(e) => setData({ ...data, "list_id": e.list_id, "actual_list_id": e.actual_list_id })} />
                <div className="shim" /> <div className="shim" />
                {/* TOGGLE TITLE & AUTHOR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW TITLE / AUTHOR</Divider>
                <Space>
                    <Checkbox checked={show_title} onChange={(e) => setData({ ...data, "show_title": e.target.checked })}><small>Show Title</small></Checkbox>
                    <Checkbox checked={show_author} onChange={(e) => setData({ ...data, "show_author": e.target.checked })} ><small>Show Author</small></Checkbox>
                </Space>
                <div className="shim" /> <div className="shim" />
                {/* TITLE TEXT */}
                {(show_title && <>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TITLE PRESET</Divider>
                    <PresetPicker value={title_preset} onChange={(e) => setData({ ...data, "title_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                </>)}
                {/* AUTHOR TEXT */}
                {(show_author && <>
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">AUTHOR PRESET</Divider>
                    <PresetPicker value={author_preset} onChange={(e) => setData({ ...data, "author_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                </>)}
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE MAX WIDTH</Divider>
                <div className="float-flex">
                    <SliderInput
                        width={90}
                        min={100}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "max_width": _v })}
                        disabled={!constrain_container}
                        value={max_width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "constrain_container": e.target.checked })} checked={constrain_container}><small>Constrain?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / GAP</Divider>
                <Space>
                    <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ps_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ps_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    <BMInput value={gap} onChange={(_v) => setData({ ...data, "gap": _v })} number min={0} max={100} prefix={<Tooltip title={tt_ps_gap}><nobr>{(!scroller && <>MIN </>)}GAP</nobr></Tooltip>} />
                </Space>
                <div className="shim" /> <div className="shim" />
                {/* NEXT / PREV BUTTONS */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">NEXT / PREV BUTTONS</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                {/* SIZE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SIZE</Divider>
                <Select value={image_size} onChange={(e) => setData({ ...data, "image_size": e })} style={{ "borderBottom": "1px solid #eee", "width": "100%" }} bordered={true}>
                    <Select.Option key={80} value={80}><small>X Small</small></Select.Option>
                    <Select.Option key={120} value={120}><small>Small</small></Select.Option>
                    <Select.Option key={190} value={190}><small>Medium</small></Select.Option>
                    <Select.Option key={230} value={230}><small>Large</small></Select.Option>
                    <Select.Option key={290} value={290}><small>X Large</small></Select.Option>
                </Select>
                <div className="shim" /> <div className="shim" />
                <BMInput value={limit} onChange={(_v) => setData({ ...data, "limit": _v })} number min={4} max={74} prefix="MAX TITLES" />
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}